import React from "react";
import ServicesSupplySolutionsImage from "../../assets/what-gel-do-image.png"; // Replace with your actual image path
import { FaCheck } from "react-icons/fa";

const ServicesSupplySolutions = () => {
  const points = [
    "Air and ocean customs clearance for import and export goods",
    "International freight forwarding with a strong global network",
    "SEZ/FTWZ clearances",
    "SVB registration, finalization (IR), and renewal",
    "Final assessment, bond closure, and customs duty/IGST refunds",
    "Bonded and non-bonded warehouse solutions",
    "DGFT consultancy and import/export licensing",
    "Bureau of Indian Standards (BIS) compliance",
    "GST and AEO consultancy",
    "Licensing and clearances for private and public bonded warehouses",
    "Pre-arrival interaction with importers/exporters for speedy customs clearance",
    "Filing and processing of applications with EOU/STPI/EHTP/SEZ authorities",
    "Arranging EPC documentation for smooth goods movement from port to importer’s premises.",
  ];

  return (
    <div className="w-full pb-12 md:py-16 px-4">
      {/* Title Section */}
      <div className="text-center mb-8 md:mb-12">
        <h2 className="text-2xl md:text-4xl text-[#011B5D] font-bold inline-block relative">
          Services &  Supply Chain Logistics Solutions
          <span className="absolute left-20 sm:left-0 right-20 sm:right-0 -bottom-2 sm:right-12  md:-bottom-3 h-1 bg-[#011B5D]"></span>
        </h2>
      </div>

      {/* Content Section */}
      <div className="flex flex-col lg:flex-row items-center justify-between gap-4 md:gap-8 mx-2 sm:mx-6 md:mx-12">
        <div className="w-full space-y-3 md:space-y-4">
          <ul className="list-disc list-inside">
            {points.map((point, index) => (
              <li key={index} className="text-sm md:text-lg mb-2 md:mb-4 leading-5 md:leading-6">
                {point}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ServicesSupplySolutions;
